<template>
  <card-box>
    <button
      title="create storefront"
      class="float-right btn btn-sm btn-light"
      @click="create"
    >
      <i class="fi-plus" />
    </button>
    <card-title>New Storefront</card-title>

    <div class="table-fluid">
      <table class="table table-striped table-responsive mt-3 w-100 d-block d-md-table">
        <tr>
          <th>NAME</th>
          <th>PATH</th>
          <th class="text-center">
            STATUS
          </th>
          <th class="text-right">
            ACTION
          </th>
        </tr>
        <tr
          v-for="item in collections"
          :key="item.id"
        >
          <td>
            <div class="custom-control custom-radio">
              <input
                :id="item.id"
                v-model="home"
                type="radio"
                class="custom-control-input"
                :value="item.id"
                name="status"
              >

              <label
                class="custom-control-label"
                :for="item.id"
              >{{ item.name }}</label>
            </div>
          </td>
          <td>
            <a
              target="_blank"
              :href="$helper.collection(item.slug)"
            >/{{ item.slug || '' }}</a>
          </td>
          <td class="text-center">
            <span
              class="badge"
              :class="{'badge-success':item.status == 1,'badge-danger': item.status == 0}"
            >{{ item.status == 1 ? 'Open':'Close' }}</span>
          </td>
          <td class="text-right">
            <router-link
              :to="{ name: 'edit_collection', params: { id: item.id }}"
              class="btn btn-light btn-sm"
            >
              <i class="dripicons-document-edit" />
            </router-link>
            <button
              class="btn btn-light btn-sm"
              @click="remove(item)"
            >
              <i class="dripicons-trash" />
            </button>
          </td>
        </tr>
      </table>
    </div>
  </card-box>
</template>

<script>
    import CardTitle from "@/components/CardTitle";
    import CardBox from "@/components/CardBox";

    export default {
        name: "Collection",
        components: {CardBox, CardTitle},
        data: function () {
            return {
                home: '',
                collections: [],
                lock: false
            }
        },
        watch: {
            home: function (val) {
                let vm = this
                this.$http.post(this.$config.api + 'collection/home/' + val).then(function (res) {
                    vm.list()
                })
            },
        },
        mounted: function () {


            this.list()
        },
        methods: {

            list: function () {
                let vm = this
                this.$http.get(this.$config.api + 'collection').then(function (res) {
                    let tmp = res.data.results
                    for (let i = 0; i < tmp.length; i++) {
                        if (tmp[i].status_home == "1") {
                            vm.home = tmp[i].id
                        }
                    }
                    vm.collections = tmp
                })
            },
            create: function () {
                if (this.lock) return
                let vm = this
                vm.lock = true
                this.$http.put(this.$config.api + 'collection').then(function (res) {
                    vm.$router.push({name: 'edit_collection', params: {id: res.data.id}})
                })
            },

            remove: function (item) {
                let vm = this
                this.$http.delete(this.$config.api + 'collection/' + item.id).then(function (res) {
                    vm.list()
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .table-fluid {
        margin-left: -20px;
        margin-right: -20px;
        padding: 0 10px;
        table {
            border: none !important;
            td {
                border: none !important;
            }
        }
    }
</style>